import * as React from 'react';
import { WTableFilterMultiselect } from './WTableFilterMultiselect';

export function generateExcelFilter(key: string, onChange: (value?: any) => void, beispiel: JSX.Element,
    getdata: () => ReadonlyArray<any>,
    attr?: any, className?: string, stampResetFilter?: number) {
    const type = attr && attr.TYPE ? attr.TYPE : '';
    return <div style={{ overflow: 'visible' }}>
        <WTableFilterMultiselect
            values={getdata()
                .map((row) => row[key])
                .sort(['DOUBLE', 'PERCENT', 'INT'].indexOf(type) !== -1 ? (a: any, b: any) => a - b : undefined)
            }
            attr={attr}
            className={className}
            onSelectionChange={onChange}
            stampResetFilter={stampResetFilter}
        />
        {beispiel}
    </div>;
}

export function getExcelFilterMethod(key: string) {
    return (filter: any, row: any) => filterExcel(row, filter, key);
}

export function getExcelFilterMethodInSubRows(key: string) {
    return (filter: any, row: any) => filterExcelInSubRows(row, filter, key);
}

function filterExcel(row: any, filter: any, key: string) {
    return (filter.value.indexOf(row[key]) !== -1);
}

function filterExcelInSubRows(row: any, filter: any, key: string): boolean {
    const subRows = row._subRows;
    if (Array.isArray(subRows)) {
        return subRows.some((r: any) => filterExcelInSubRows(r, filter, key));
    } else {
        return filterExcel(row, filter, key);
    }
}
